import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import reporteService from "../services/reporteService";
import { message } from "utils/Funciones";

const initialState = {
    responseSuccessCreate: null,
    responseSuccessGet: null,
    responseSuccessUpdate: null,
    responseSuccessAnular: null,
    responseSuccessDelete: null,
    reporteGeneral: {
        totalVentas: 0,
        totalIngresos: 0,
        totalProductos: 0,
        totalGanancias: 0,
        totalDescuentos: 0,
        ventaPromedio: 0
    },
    dataByPageProduct: [],
    dataByPageUser: [],
    totalRowProduct: 0,
    totalRowUser: 0,
    totalPageProduct: 0,
    totalPageUser: 0,
    isError: false,
    isSuccess: false,
    isLoadingProduct: false,
    isLoadingUser: false,
    isLoading: false,
    message: "",
    totalStoreValue: 0
};

export const getByPageProduct = createAsyncThunk(
    "reporte/getByPageProduct/bypageproduct",
    async (data, thunkAPI) => {
        try {
            return await reporteService.getByPageProduct(data.query);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getByPageUser = createAsyncThunk(
    "reporte/getByPageUser/bypageuser",
    async (data, thunkAPI) => {
        try {
            return await reporteService.getByPageUser(data.query);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getReporteGeneral = createAsyncThunk(
    "reporte/getReporteGeneral/reportegeneral",
    async (data, thunkAPI) => {
        try {
            return await reporteService.getReporteGeneral(data.query);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

const reporteSlice = createSlice({
    name: "reporte",
    initialState,
    reducers: {
        SET_TO_DEFAULT_RESPONSE(state, action) {
            state.responseSuccessCreate = null
            state.responseSuccessGet = null
            state.responseSuccessAnular = null
            state.responseSuccessUpdate = null
            state.responseSuccessDelete = null
        },

        UPDATE_REPORTE_FROM_SOCKET(state, action) {


        },
    },
    extraReducers: (builder) => {
        builder
            //____________________GET_BY_PAGE_PRODUCT____________________//
            .addCase(getByPageProduct.pending, (state) => {
                state.isLoadingProduct = true;
            })
            .addCase(getByPageProduct.fulfilled, (state, action) => {
                state.dataByPageProduct = action.payload.data;
                state.totalPageProduct = action.payload.totalPage;
                state.totalRowProduct = action.payload.totalRow;
                state.isLoadingProduct = false;
            })
            .addCase(getByPageProduct.rejected, (state, action) => {
                state.isLoadingProduct = false;
            })
            //____________________GET_BY_PAGE_USER____________________//
            .addCase(getByPageUser.pending, (state) => {
                state.isLoadingUser = true;
            })
            .addCase(getByPageUser.fulfilled, (state, action) => {
                state.dataByPageUser = action.payload.data;
                state.totalPageUser = action.payload.totalPage;
                state.totalRowUser = action.payload.totalRow;
                state.isLoadingUser = false;
            })
            .addCase(getByPageUser.rejected, (state, action) => {
                state.isLoadingUser = false;
            })
            //____________________GET_GENERAL____________________//
            .addCase(getReporteGeneral.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getReporteGeneral.fulfilled, (state, action) => {
                state.reporteGeneral = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getReporteGeneral.rejected, (state, action) => {
                state.isLoading = false;
            })
    },
});

export const { UPDATE_REPORTE_FROM_SOCKET, SET_TO_DEFAULT_RESPONSE } = reporteSlice.actions;

export default reporteSlice.reducer;

